// AdminAlertsPage.js â€” /admin/alerts
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../../firebaseConfig';
import Layout from '../Layout';
import { AdminLoadingBar, AdminLoadingStyles, AdminSpinner } from './AdminLoadingUi';

async function adminFetch(path, opts = {}) {
  const token = await auth.currentUser.getIdToken();
  const res   = await fetch(path, { ...opts, headers: { Authorization: `Bearer ${token}`, ...(opts.headers || {}) } });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export default function AdminAlertsPage() {
  const [alerts,   setAlerts]   = useState([]);
  const [showAll,  setShowAll]  = useState(false);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState('');

  const load = async (all) => {
    setLoading(true); setError('');
    try {
      const data = await adminFetch(`/api/admin/alerts?limit=200&showAll=${all}`);
      setAlerts(data.alerts);
    } catch (e) { setError(e.message); }
    setLoading(false);
  };

  useEffect(() => { load(showAll); }, [showAll]);

  async function dismiss(id) {
    try {
      await adminFetch(`/api/admin/alerts/${id}/dismiss`, { method: 'POST' });
      setAlerts((prev) => prev.filter((a) => a.id !== id));
    } catch (e) { alert('Failed: ' + e.message); }
  }

  const page  = { fontFamily: 'sans-serif', padding: '28px 32px', maxWidth: 1100, margin: '0 auto', color: '#1e293b' };
  const badge = (type) => ({
    display: 'inline-block', padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 700,
    background: type === 'HIGH_REQUEST_RATE' ? '#fee2e2' : '#fef3c7',
    color:      type === 'HIGH_REQUEST_RATE' ? '#dc2626' : '#d97706',
  });

  return (
    <Layout>
    <div style={page}>
      <AdminLoadingStyles />
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
        <Link to="/admin" style={{ color: '#64748b', textDecoration: 'none', fontSize: 14 }}>← Admin Panel</Link>
        <h1 style={{ margin: 0, fontSize: 24, display: 'flex', alignItems: 'center', gap: 10 }}>
          <span>Security Alerts</span>
          <AdminSpinner loading={loading} />
        </h1>
        <label style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer' }}>
          <input type="checkbox" checked={showAll} onChange={(e) => setShowAll(e.target.checked)} />
          Show dismissed
        </label>
      </div>
      <AdminLoadingBar loading={loading} />

      {error   && <div style={{ color: '#dc2626', marginBottom: 12 }}>Error: {error}</div>}

      {!loading && alerts.length === 0 && (
        <p style={{ color: '#64748b' }}>No alerts{showAll ? '' : ' pending'}.</p>
      )}

      {!loading && alerts.length > 0 && (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f1f5f9' }}>
              {['Type', 'Phone', 'IP', 'Detail', 'Time', 'Status', 'Action'].map((h) => (
                <th key={h} style={{ padding: '9px 12px', textAlign: 'left', fontWeight: 600, color: '#475569' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {alerts.map((a) => (
              <tr key={a.id} style={{ borderTop: '1px solid #e2e8f0', opacity: a.dismissed ? 0.5 : 1 }}>
                <td style={{ padding: '9px 12px' }}><span style={badge(a.type)}>{a.type}</span></td>
                <td style={{ padding: '9px 12px' }}>
                  {a.phone
                    ? <Link to={`/admin/users/${encodeURIComponent(a.phone)}`} style={{ color: '#3b82f6' }}>{a.phone}</Link>
                    : <span style={{ color: '#64748b' }}>â€”</span>
                  }
                </td>
                <td style={{ padding: '9px 12px', fontFamily: 'monospace', fontSize: 12 }}>{a.ip || 'â€”'}</td>
                <td style={{ padding: '9px 12px' }}>
                  {a.type === 'HIGH_REQUEST_RATE' && `${a.requestCount} requests in ${a.windowMin} min`}
                  {a.type === 'MULTI_USER_IP'     && `${a.uniqueUserCount} unique users from IP`}
                </td>
                <td style={{ padding: '9px 12px', color: '#64748b', whiteSpace: 'nowrap' }}>
                  {a.createdAt ? new Date(a.createdAt).toLocaleString() : 'â€”'}
                </td>
                <td style={{ padding: '9px 12px' }}>
                  {a.dismissed
                    ? <span style={{ color: '#94a3b8', fontSize: 12 }}>Dismissed</span>
                    : <span style={{ color: '#16a34a', fontSize: 12, fontWeight: 600 }}>Pending</span>
                  }
                </td>
                <td style={{ padding: '9px 12px' }}>
                  {!a.dismissed && (
                    <button onClick={() => dismiss(a.id)} style={{ fontSize: 12, padding: '4px 10px', border: '1px solid #cbd5e1', borderRadius: 4, cursor: 'pointer', background: '#fff' }}>
                      Dismiss
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
    </Layout>
  );
}
